export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      4746.417233560091,
    ],
    button_spin: [
      6000,
      730.7482993197283,
    ],
    buy_button: [
      8000,
      2594.7619047619046,
    ],
    end_free_spin: [
      12000,
      8021.043083900224,
    ],
    free_bet_big_win: [
      22000,
      1362.3129251700695,
    ],
    free_bet_mega_win: [
      25000,
      2207.913832199548,
    ],
    free_bet_total_win: [
      29000,
      973.3560090702938,
    ],
    free_bet_ultra_win: [
      31000,
      1297.414965986391,
    ],
    free_spin_ambient: [
      34000,
      32718.344671201805,
    ],
    free_spin_music: [
      68000,
      44822.44897959184,
    ],
    free_spin_popup: [
      114000,
      4856.666666666669,
    ],
    free_spin_start: [
      120000,
      4041.700680272115,
    ],
    inside_buttons: [
      126000,
      257.755102040818,
    ],
    main_ambient: [
      128000,
      54131.17913832201,
    ],
    main_music: [
      184000,
      169923.9909297052,
    ],
    mega_win: [
      355000,
      8124.875283446727,
    ],
    outside_buttons: [
      365000,
      673.4467120181193,
    ],
    reel_spin: [
      367000,
      2155.668934240339,
    ],
    reel_stop_01: [
      371000,
      161.79138321996334,
    ],
    reel_stop_02: [
      373000,
      191.08843537412668,
    ],
    reel_stop_03: [
      375000,
      180.24943310655317,
    ],
    reel_stop_04: [
      377000,
      162.85714285714903,
    ],
    reel_stop_05: [
      379000,
      162.87981859409228,
    ],
    regular_win: [
      381000,
      1106.3265306122503,
    ],
    scatter_chance: [
      384000,
      3737.029478458055,
    ],
    scatter_stop: [
      389000,
      1644.9433106575952,
    ],
    tap_to_play: [
      392000,
      6143.08390022677,
    ],
    ultra_win: [
      400000,
      5269.5918367347185,
    ],
  },
}
